import icon from '@/presentation/assets/images/icons/tool-fto.svg';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, type ToolConfig, PAGE_TYPE } from '@/types/manifest.ts';

const FTO_NEW_ROUTER_NAME = 'fto-pro';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: FTO_NEW_ROUTER_NAME,
    exclusiveRoutePath: '/fto-pro',
    getComponent: () => {
        return import('./FtoPro.vue');
    },
};

const toolConfig: ToolConfig = {
    tabIndex: 2,
    label: 'drafting.fto-pro',
    icon,
    aclCheckPath: (permission) => true,
};

export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 FTO New 页面
         * @param commandId - 命令(去到 FTO New 页面)
         * @param params - 参数(包含任务 ID)
         */
        executeCommand(commandId: 'command:route:fto-pro', params?: CustomQueryParams): void;
    }
}
